export default {
  'Account': 'Cuenta',
  'Already with an account?': '¿Ya tienes una cuenta?',
  'and': 'y',
  'Cancel subscription': 'Cancelar suscripción',
  'Catalogs': 'Catálogos',
  'Change profile picture': 'Cambiar imagen de perfil',
  'comingsoon': '¡Esta función llegará pronto!',
  'Community': 'Comunidad',
  'confirmed': 'confirmado',
  'Connect': 'Conectar',
  'Consent': 'Consentimiento',
  'copy': 'copiar',
  'Copy': 'Copiar',
  'Courses': 'Cursos',
  'Decline': 'Disminución',
  'Disconnect': 'Desconectar',
  'Email': 'Correo electrónico',
  'Examples': 'Ejemplos',
  'Features': 'Características',
  'Filter categories': 'Filtrar categorías',
  'Firstname': 'Nombre de pila',
  'Flightschool': 'Escuela de vuelo',
  'Home': 'Casa',
  'I agree to the': 'Estoy de acuerdo con el',
  'Imprint': 'Imprimir',
  'Lastname': 'Apellido',
  'Learn': 'Aprender',
  'Learning': 'Aprendizaje',
  'Lections': 'Lecciones',
  'Listening': 'Escuchando',
  'login': 'Iniciar sesión',
  'Login': 'Iniciar sesión',
  'logout': 'Cerrar sesión',
  'Mark as read': 'Marcar como leído',
  'month': 'mes',
  'Month': 'Mes',
  'Monthly': 'Mensual',
  'or': 'o',
  'password': 'contraseña',
  'Password': 'Contraseña',
  'per': 'por',
  'Phone': 'Teléfono',
  'Positive': 'Positivo',
  'Pricing': 'Precios',
  'privacy': 'Privacidad',
  'Privacy': 'Privacidad',
  'privacyagreement': 'Acepto el acuerdo de protección de datos y los términos de servicio.',
  'product': 'producto',
  'Product': 'Producto',
  'profile': 'Perfil',
  'Question': 'Pregunta',
  'Questions': 'Preguntas',
  'Read more': 'Lee mas',
  'Register': 'Registro',
  'Remove': 'Eliminar',
  'Report a bug': 'Informar de un error',
  'Request': 'Solicitud',
  'Resume subscription': 'Reanudar suscripción',
  'Scenarios': 'Escenarios',
  'School': 'Escuela',
  'Search': 'Buscar',
  'Seen': 'Visto',
  'Send': 'Enviar',
  'Settings': 'Ajustes',
  'Show hint again': 'Mostrar pista de nuevo',
  'Simulator': 'Simulador',
  'Spelling': 'Ortografía',
  'Submit': 'Enviar',
  'Subscription': 'Suscripción',
  'Tools': 'Herramientas',
  'tos': 'Términos de servicio',
  'Tos': 'Términos de servicio',
  'Total': 'Total',
  'username': 'nombre de usuario',
  'Username': 'Nombre de usuario',
  'Wiki': 'Wiki',
  'Write': 'Escribir',
  'Year': 'Año',
  'Yearly': 'Anual',
  'Your Name': 'Tu nombre',
  'Exam': 'Examen',
  'Unlimited': 'Ilimitado',
  'Time limit': 'Límite de tiempo',
  'Started': 'Iniciado',
  'Completed': 'Completado',
  'Percentage': 'Porcentaje',
  'Tries': 'Intentos',
  'License': 'Licencia',
  'Exampreparation': 'Preparación de exámenes',
  'Finish': 'Finalizar',
}
